exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__TableWithProps__head-cell {\n  all: initial;\n  font-family: var(--font-family);\n}\n.DS__TableWithProps__head-cell {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n", ""]);

// exports
exports.locals = {
	"head-cell": "DS__TableWithProps__head-cell"
};